import { PAGE_MAX, PAGE_GUTTER_X } from "../../../layout/pageShell";

/**
 * Landing sections use the same 1200px shell + gutters as the rest of the marketing site.
 */
export const LANDING_MAX = PAGE_MAX;
export const LANDING_PAD_X = PAGE_GUTTER_X;
export const LANDING_PAD_X_BLEED = PAGE_GUTTER_X;
